// extracted by mini-css-extract-plugin
export var videoHero = "_bc-4";
export var videoHeroImage = "_bc-5";
export var videoHeroOverlay = "_bc-6";
export var videoHeroSubtitle = "_bc-8";
export var videoHeroText = "_bc-7";
export var videoLauncher = "_bc-0";
export var videoLauncherIcon = "_bc-1";
export var videoLauncherSubtitle = "_bc-3";
export var videoLauncherTitle = "_bc-2";
export var videoPlayer = "_bc-a";
export var videoPlayerWrap = "_bc-9";